import { handleDataInvoice } from '@/utils/invoice';
import BaseProxy from './base-proxy';

/**
 * Class EInvoiceServiceProxy
 */
class EInvoiceServiceProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-service-api/api/e-invoices', parameters);
    this.defaultOptions = { allowToast: false };
  }

  createEInvoiceService(payload, options = {}) {
    const data = handleDataInvoice(payload);
    return this.submit('post', `${this.endpoint}/create`, data, { ...this.defaultOptions, ...options });
  }

  searchEInvoiceService(code, options = {}) {
    return this.submit('get', `${this.endpoint}/search/${code}`, null, { ...this.defaultOptions, ...options });
  }

  getActiveSeries(options = {}) {
    return this.submit('get', `${this.endpoint}/active-series`, null, { ...this.defaultOptions, ...options });
  }

  addExplanation(payload, options = {}) {
    const { id, ...data } = payload;
    return this.submit('put', `${this.endpoint}/add-explanation/${id}`, data, { ...this.defaultOptions, ...options });
  }
}

export default EInvoiceServiceProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice-service-proxy.js